export default {"src":"/_next/static/media/fFRAX.8ba51c30.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};